import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    transition: "transform 0.3s ease-in-out",
    position: "fixed !important",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: theme.zIndex.appBar,
  },
  backdropFilter: {
    width: "100%",
    position: "fixed",
    zIndex: 0,
    backdropFilter: "blur(18px)",
    height: "100%",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  menu: {
    padding: theme.spacing.space8,
  },
  icon: {
    color: theme.colors.Background7,
  },
  show: {
    visibility: "unset",
  },
  hide: {
    visibility: "hidden",
  },
}));
